module.exports = __webpack_public_path__ + "static/img/Saleem Ahmed Shaikh.dd2b5e37.png";